import 'css-chunksrc/client/common/filterMenu/projectsTags/styles.scss';export default {
  "header": "_header_1h64v_1",
  "icon": "_icon_1h64v_10",
  "title": "_title_1h64v_18",
  "list": "_list_1h64v_25"
};